export default __webpack_public_path__ + "static/media/wakyu.10f9b0cc.png";